import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { Link } from 'react-router-dom';
import { HelpCircle, ArrowRight } from 'lucide-react';
import { faqs } from '../data/mock';

const FAQ = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-blue-100 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="bg-blue-100 rounded-full p-4">
              <HelpCircle className="w-16 h-16 text-blue-600" />
            </div>
          </div>
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            Foire Aux <span className="text-blue-600">Questions</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Trouvez rapidement des réponses aux questions les plus fréquemment posées
          </p>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq) => (
              <AccordionItem 
                key={faq.id} 
                value={`item-${faq.id}`}
                className="bg-white border-2 border-gray-200 rounded-lg px-6 hover:border-blue-600 transition-colors duration-200"
              >
                <AccordionTrigger className="text-left hover:no-underline py-6">
                  <span className="text-lg font-semibold text-gray-900 pr-4">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-6 pt-2">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* Still Have Questions */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl shadow-xl p-12 text-center text-white">
            <h2 className="text-3xl font-bold mb-4">
              Vous n'avez pas trouvé votre réponse?
            </h2>
            <p className="text-xl text-blue-100 mb-8">
              Notre équipe est là pour répondre à toutes vos questions
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-blue-600 bg-white rounded-lg hover:bg-gray-100 transition-all duration-200 shadow-lg hover:shadow-xl"
            >
              Contactez-nous
              <ArrowRight className="ml-2 w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>

      {/* Additional Help */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Ressources utiles
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Link
              to="/services"
              className="bg-blue-50 border-2 border-blue-200 rounded-xl p-6 hover:border-blue-600 hover:shadow-lg transition-all duration-200 group"
            >
              <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-blue-600">
                Nos services
              </h3>
              <p className="text-gray-600 mb-4">
                Découvrez tous les services que nous offrons pour répondre à vos besoins.
              </p>
              <span className="inline-flex items-center text-blue-600 font-semibold">
                En savoir plus
                <ArrowRight className="ml-2 w-4 h-4" />
              </span>
            </Link>

            <Link
              to="/tarifs"
              className="bg-green-50 border-2 border-green-200 rounded-xl p-6 hover:border-green-600 hover:shadow-lg transition-all duration-200 group"
            >
              <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-green-600">
                Tarifs
              </h3>
              <p className="text-gray-600 mb-4">
                Consultez nos tarifs transparents et compétitifs pour chaque service.
              </p>
              <span className="inline-flex items-center text-green-600 font-semibold">
                Voir les tarifs
                <ArrowRight className="ml-2 w-4 h-4" />
              </span>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
